module.exports = __webpack_public_path__ + "media/images/icon-transform-1dc68ef17c2d0e2777a8e5e187c3f544.svg";